export function useAdyenEnvironment() {
  return { clientKey: ETSY_ADYEN_CLIENT_KEY, environment: ADYEN_ENVIRONMENT };
}
